
import { useEffect, useState } from "react";
import { apiGet, apiPost } from '../../API/httpCommon';
import { setEmitFlags } from "typescript";
import Spinner from '../Spinner/Spinner';

const BulkOrder = () => {


    const [isLoading, setIsLoading] = useState(false);
    const [TypeofCustomer, setTypeofCustomer] = useState('');
    const [Name, setName] = useState('');
    const [Email, setEmail] = useState('');
    const [ContactNo, setContactNo] = useState('');
    const [Message, setMessage] = useState('');
    const [Quantity, setQuantity] = useState('');
    const [ShowAlert, setShowAlert] = useState(false);

    const isValid = () => {
        
        var result: Boolean = true;

        if (!Name) {
            result = false;
        }

        if (!ContactNo) {
            result = false;
        }

        if (!Quantity) {
            result = false;
        }

        if (!Message) {
            result = false;
        }

        return result;
    }

    const SendMail = () => {
        
        if (!isValid()) {
            alert('Please fill all required fields');
            return false;
        }



        setIsLoading(true);
        const data = {
            TypeOfCustomer: TypeofCustomer,
            Name: Name,
            Email: Email,
            ContactNo: ContactNo,
            Message: Message,
            Quantity: Quantity
        }
        
        apiPost("api/Email/BulkOrder", data).then((res: any) => {
           
            setTypeofCustomer('');
            setName('');
            setEmail('');
            setContactNo('');
            setMessage('');
            setQuantity('');

            setIsLoading(false);
            setShowAlert(true);
        });
    }


    const handleChangeTypeofCustomer = (event: any) => {
        
        setTypeofCustomer(event.target.value);
    };

    return (<>

{(isLoading && <Spinner></Spinner>)}
        {/* <!-- Breadcumb Section Start --> */}
        <div className="breadcrumb-img">
            <img src="assets/img/banner/bulk-banner.jpg" alt="MeriPustak-About" />

        </div>

        {/* <!-- Contact Section Start --> */}
        <section className="contact-section fix section-padding">
            <div className="container">
                <div className="contact-wrapper">
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="contact-left-items">
                                <p className="wow fadeInUp" data-wow-delay=".3s">We understand the importance of your growing business needs and it saves a lot of effort, every time you put a bulk order.</p>
                                <p className="wow fadeInUp" data-wow-delay=".5s">MeriPustak is the one stop shop for all your corporate/Institute readers. Bookss are available from all publishers and categories such as Medical, Taxation, Legal & Regulatory, Engineering and Academic, Science, Mathematics and so on.</p>
                                <h3 className="wow fadeInUp" data-wow-delay=".5s">What is a BULK Order?</h3>
                                <p className="wow fadeInUp" data-wow-delay=".7s">Any order for more than 5 items of the same kind/type and value exceeding Rs. 15000 will be treated as a bulk order.</p>
                                <p className="wow fadeInUp" data-wow-delay=".7s">Place your Bulk Order here! Our team will reach out in order to meet your specific requirements.</p>

                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="contact-content">
                                <h2 className="wow fadeInUp" data-wow-delay=".3s">Place your Bulk Order Here:-</h2>

                                <form action="#" id="contact-form" method="POST" className="contact-form-items">
                                    <div className="row g-4">
                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                                            <div className="form-clt">
                                                <span>Type of Customer*</span>
                                                <select value={TypeofCustomer}  onChange={handleChangeTypeofCustomer} name="Customer" id="Customer">
                                                    <option value="">Select</option>
                                                    <option value="Corporate">Corporate</option>
                                                    <option value="Retail">Retail</option>
                                                    <option value="Institution">Institution</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".3s">
                                            <div className="form-clt">
                                                <span>Your name*</span>
                                                <input type="text" value={Name} onChange={(e: any) => { setName(e.target.value) }} name="name" id="name" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 wow fadeInUp" data-wow-delay=".5s">
                                            <div className="form-clt">
                                                <span>Your Email*</span>
                                                <input type="text" value={Email} onChange={(e: any) => { setEmail(e.target.value) }} name="email" id="email" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s">
                                            <div className="form-clt">
                                                <span>Phone No.*</span>
                                                <input type="number" value={ContactNo} onChange={(e: any) => { setContactNo(e.target.value) }} name="phone" id="phone" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 wow fadeInUp" data-wow-delay=".5s">
                                            <div className="form-clt">
                                                <span>Order Quantity*</span>
                                                <input type="number" value={Quantity} onChange={(e: any) => { setQuantity(e.target.value) }} name="phone" id="phone" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-lg-12 wow fadeInUp" data-wow-delay=".7s">
                                            <div className="form-clt">
                                                <span>Write Message*</span>
                                                <textarea name="message" value={Message} onChange={(e: any) => { setMessage(e.target.value) }} id="message"
                                                    placeholder=""></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-7 wow fadeInUp" data-wow-delay=".9s">
                                            <button type="button" onClick={SendMail} className="theme-btn">
                                                Send Message <i className="fa-solid fa-arrow-right-long"></i>
                                            </button>
                                        </div>
                                        <div className="col-lg-12 wow fadeInUp" data-wow-delay=".9s">
                                            {ShowAlert && <div className="alert alert-success">
                                                Thanks for contacting us. We will get back to you at the earliest.
                                            </div>}
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>




    </>);
};

export default BulkOrder;